import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconPlay = ({ className }) => {
    return (
        <svg
            className={'icon-play' + (className ? ` ${className}` : '')}
            fill='none'
            height='80'
            width='80'
            xmlns='http://www.w3.org/2000/svg'><g filter='url(#a)'><circle
                cx='40'
                cy='40'
                fill='#fff'
                r='40'/><circle
                cx='40'
                cy='40'
                r='39.5'
                stroke='#6C6C6C'/></g><path
                d='m33.5523 25.8696 20.2909 14.5518-20.2909 14.5518V25.8696Z'
                stroke='#6C6C6C'/><defs><filter
                colorInterpolationFilters='sRGB'
                filterUnits='userSpaceOnUse'
                height='160'
                id='a'
                width='160'
                x='-40'
                y='-40'><feFlood
                    floodOpacity='0'
                    result='BackgroundImageFix'/><feGaussianBlur
                    in='BackgroundImageFix'
                    stdDeviation='20'/><feComposite
                    in2='SourceAlpha'
                    operator='in'
                    result='effect1_backgroundBlur_1_23216'/><feBlend
                    in='SourceGraphic'
                    in2='effect1_backgroundBlur_1_23216'
                    result='shape'/></filter></defs></svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string
};

IconPlay.propTypes = propTypes;

export default IconPlay;
